import { render, staticRenderFns } from "./crudCash.vue?vue&type=template&id=99bff80e&scoped=true&"
import script from "./crudCash.vue?vue&type=script&lang=js&"
export * from "./crudCash.vue?vue&type=script&lang=js&"
import style0 from "./crudCash.vue?vue&type=style&index=0&id=99bff80e&prod&lang=css&"
import style1 from "./crudCash.vue?vue&type=style&index=1&id=99bff80e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bff80e",
  null
  
)

export default component.exports